import { RATE_PER_SPACE_SIZE_UNIT_PER_YEAR, PERCENT_OF_RENT } from '../commission_modes';

export function updateCommission(leaseTerm, spaceSize, commissionMode) {
  if (commissionMode === PERCENT_OF_RENT) {
    if (leaseTerm.commissionUnits === 'commission_units_dollars') {
      leaseTerm.commissionPercent = getCommissionPercentFromAmount(leaseTerm, leaseTerm.commissionAmount);
    } else {
      leaseTerm.commissionAmount = getCommissionAmountFromPercent(leaseTerm, leaseTerm.commissionPercent);
    }

    leaseTerm.commissionRate = getCommissionRateFromAmount(leaseTerm, leaseTerm.commissionAmount, spaceSize);
  } else {
    if (leaseTerm.commissionUnits === 'commission_units_dollars') {
      leaseTerm.commissionRate = getCommissionRateFromAmount(
        leaseTerm,
        leaseTerm.commissionAmount,
        spaceSize,
        commissionMode
      );
    } else {
      leaseTerm.commissionAmount = getCommissionAmountFromRate(
        leaseTerm,
        leaseTerm.commissionRate,
        spaceSize,
        commissionMode
      );
    }

    leaseTerm.commissionPercent = getCommissionPercentFromAmount(leaseTerm, leaseTerm.commissionAmount);
  }

  return leaseTerm;
}

export function updateCommissionTransactionSide(leaseTerm, spaceSize, commissionMode, transactionSide) {
  const transactionSideDetails = leaseTerm.transactionSideDetails.find(
    details => details.transactionSide === transactionSide
  );
  
  if (commissionMode === PERCENT_OF_RENT) {
    if (transactionSideDetails.grossUnit === 'unit_dollars') {
      transactionSideDetails.grossPercent = getCommissionPercentFromAmount(
        leaseTerm,
        transactionSideDetails.grossAmount
      );
    } else {
      transactionSideDetails.grossAmount = getCommissionAmountFromPercent(
        leaseTerm,
        transactionSideDetails.grossPercent
      );
    }

    transactionSideDetails.grossRate = getCommissionRateFromAmount(
      leaseTerm,
      transactionSideDetails.grossAmount,
      spaceSize
    );
  } else {
    if (transactionSideDetails.grossUnit === 'unit_dollars') {
      transactionSideDetails.grossRate = getCommissionRateFromAmount(
        leaseTerm,
        transactionSideDetails.grossAmount,
        spaceSize,
        commissionMode
      );
    } else {
      transactionSideDetails.grossAmount = getCommissionAmountFromRate(
        leaseTerm,
        transactionSideDetails.grossRate,
        spaceSize,
        commissionMode
      );
    }

    transactionSideDetails.grossPercent = getCommissionPercentFromAmount(
      leaseTerm,
      transactionSideDetails.grossAmount
    );
  }

  return leaseTerm;
}

function getCommissionAmountFromPercent(leaseTerm, percent) {
  if (leaseTerm.leaseAmount && percent != null) {
    return leaseTerm.leaseAmount * percent / 100.0;
  }
  return percent == null ? null : 0;
}

function getCommissionAmountFromRate(leaseTerm, rate, spaceSize, commissionMode) {
  if (spaceSize != null && leaseTerm.months != null && rate != null) {
    let commissionAmount = rate * spaceSize * leaseTerm.months;
    if (commissionMode === RATE_PER_SPACE_SIZE_UNIT_PER_YEAR) {
      commissionAmount = commissionAmount / 12;
    }
    return commissionAmount;
  } else {
    return rate == null ? null : 0;
  }
}

function getCommissionPercentFromAmount(leaseTerm, amount) {
  if (leaseTerm.leaseAmount && amount != null) {
    return amount / leaseTerm.leaseAmount * 100.0;
  }
  return amount == null ? null : 0;
}

function getCommissionRateFromAmount(leaseTerm, amount, spaceSize, commissionMode) {
  let commissionRate;
  if (spaceSize && leaseTerm.months && amount != null) {
    commissionRate = amount / spaceSize / leaseTerm.months;
    if (commissionMode === RATE_PER_SPACE_SIZE_UNIT_PER_YEAR) {
      commissionRate = commissionRate * 12;
    }
  } else {
    commissionRate = amount == null ? null : 0;
  }

  return commissionRate;
}
